import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { Login } from '@df/session/login/login.interfaces';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { AddressFieldsetComponent } from 'projects/app-default/src/app/ui/form/address-fieldset/address-fieldset.component';
import { InputWrapBodyDirective } from 'projects/app-default/src/app/ui/form/input-wrap-body.directive';
import { InputWrapComponent } from 'projects/app-default/src/app/ui/form/input-wrap.component';
import { FormWizardStepAbstract } from '../../../../../ui/form/wizard/step/form-wizard-step.abstract';
@Component({
    selector: 'login-form-trade-step-2',
    templateUrl: './login-form-trade-step-2.component.html',
    standalone: true,
    imports: [FormsModule, TranslationModule, InputWrapComponent, InputWrapBodyDirective, AddressFieldsetComponent, MuiInputDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormTradeStep2Component extends FormWizardStepAbstract {
    @Input()
    data: Login.IRegisterFormData;
}
